const formatModalidad = (value) => {
  const modalidades = {
    en_linea: "En línea",
    presencial: "Presencial",
    hibrida: "Híbrida",
  };

  return modalidades[value] || value;
};

const Modalidad = ({ value }) => {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return null;
  }

  const modalidades = (Array.isArray(value) ? value : [value])
    .filter(Boolean)
    .map(formatModalidad);

  return <>{modalidades.join(" / ")}</>;
};

export default Modalidad;